<template>
    <div>
    <h2> Fey Court:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg', 'Fey Court')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/232522319/iFJwuSjNpIadT5b3knBwLg/original.jpg?162553768055" target="_blank">Map</a><br/>
    The Fey Court is the Hard difficulty encounter with a CR of 14 on floor 3. It is arena style, so monsters will continue to enter as player defeat waves.
    <v-row>
        <v-col>
            <img id="Fey Court" :src="require('../../../assets/Annotated_Fey_Court_Map.png')"  contain width="850px"/>
        </v-col>
        <v-col>
        <h4>Map Details: </h4>
        <ul>
            <li>This encounter takes place in a throne room on the first world.</li>
            <li>The whole area is brightly lit and players can see the whole map.</li>
            <li>the roof to this area is 60 feet tall.</li>
            <li>Monsters spawn at either spawnpoint 1, or 2 if there are more players near spawnpoint 1 than spawnpoint 2.</li>
            <li>For every item on this map a player can as a movement action attempt to reduce the cost of an item by 25 gold. This requires a DC 30 knowledge nature check. If they fail by 10 or more the price of the chest increases by 25 gold. They can attempt this check while spending a movement action to open this chest, but if they fail the check they must still buy it. They cannot attempt this check multiple times, but different players can attempt it.</li>
            <li>Map is 23x48</li>
            <li><b>Color Code:</b></li>
            <ul>
                <li>Player Spawn: Pink</li>
                <li>Treasure: Gold</li>
                <li>Area Of Interest: Green</li>
                <li>Monster Spawns: Red</li>
                <li>Terrain of Note: White</li>
            </ul>                 
        </ul>
        <br/><br/>
        
    <h4>Monsters:</h4>
        <ul>
            <li><b>Wave 1 CR 14: </b> </li>
            Wave 1 starts as soon as the players enter the floor. If players defeat this wave they are immediately rewarded with a large gold pile.
            <ul>
                <li><b>1) 2x Kallas Devil CR 9: </b> Note Kallas Devil disease is Mortasheen: Contact; save Fort DC 21; frequency 1/day; effect 1d4 Con and target is fatigued; cure 2 consecutive saves.</li>
                <li><b>2) White Rider CR 11: </b> Enters riding steed as if spell conjure steed at caster level 13</li>
                <li><b>3) Red Rider CR 12: </b> Enters riding steed as if spell conjure steed at caster level 13 </li>
            </ul>            
            <br/>
            <li><b>Wave 2 CR 15: </b> </li>
            Wave 2 begins once both riders from previous wave are slain, or one rider and both Kallas Devils. 
            <ul>
                <li><b>1) Black Rider CR 13: </b> Enters riding steed as if spell conjure steed at caster level 13</li>
                <li><b>2) Ankou CR 14: </b></li>
            </ul>
            <br/>
            <li><b>Wave 3 CR 16: </b> </li>
            Wave 3 begins once both monsters from previous wave are defeated. If players defeat this wave they are immediately rewarded with a large gold pile.
            <ul>
                <li><b>1) Vilderavn CR 16: </b> Starts in its human form.</li>
            </ul>
            <br/>
            <li><b>Wave 4 CR 18: </b> </li>
            Wave 4 one full round after Vilderavn is defeated.
            <ul>
                <li><b>1) Trunche CR 17: </b> </li>
                <li><b>2) 2x Zana CR 14: </b> </li>
            </ul>
            <br/>
            <li><b>Wave 5 CR 19: </b> </li>
            Wave 5 begins 5 full rounds after 2/3 of the previous wave are defeated. If Players defeat this wave they are rewarded with a unique perk, a large pile of gold.
            <ul>
                <li><b>1) Crone Queen CR 15: </b> If players can slay the Crone Queen they are immediately rewarded with a medium pile of gold</li>                
                <li><b>2) 2x Vilderavn CR 16: </b> Starts in its human form. If slain players are rewarded with a medium pile of gold</li>
            </ul>
        </ul>
        <br/><br/>

        <h4>Treasure:</h4>
        <ul>
            <li><b>1) Rare Typed Perk 125: </b> Note: this means player can choose from a fighter perk, gambit, Ki Perk, Rogue Talent, or Rage Power </li>
            <li><b>2) Perk 100</b></li>
            <li><b>3) 4-8 Typed Potions 50 </b> </li>
            <li><b>4) Level Up 200</b></li>
            <li><b>5) U Enchanted Typed U Weapon 150</b></li>
            <li><b>6) Resurrective 100</b></li>
            <li><b>7) E+ Weapon Enchantment 125</b></li>
            <li><b>8) 2x Stats 50</b></li>
            <li><b>9) E+ Armor Enchantment 125</b></li>
            <li><b>10) Typed Spell/Maneuver 40</b></li>
            <li><b>11) Metamagic feat 125: </b></li>
            <li><b>12) 2x Stats 50: </b></li>
            <li><b>13) Roll 2x Feat 175</b></li>
            <li><b>14) 4-8 Potions 25</b></li>
            <li><b>15) R+ armor Enchantment 125</b></li>
            <li><b>16) 4-8 Potions 25 </b></li>
            <li><b>17) E+ Weapon Enchantment 150 </b></li>
            <li><b>18) Spell/Maneuver 40 </b></li>
            <li><b>19) Ki Perk 125</b></li>
            <li><b>20) Resurrective 100</b></li>
            <li><b>21) Resurrective 100</b></li>
            <li><b>22) Typed Spell/Maneuver 60</b></li>
            <li><b>23) Stats 50</b></li>
            <li><b>C) 2x Level Up Cursed Chest: </b> If players activate cursed chest it spawns a Erlking, and rewards two level ups if it is defeated.</li>
        </ul>
        <br/><br/>

        <h4>Areas of Interest: </h4>
        <ul>
            <li><b>1) Trapped Lily Pad: </b> If a player enters onto a square containing a trapped lily pad, or interacts with an item on it, such as to obtain an item on it, they must make a will save DC 22 or become dazed for the rest of their turn. A perception check DC 34 can detect a lily pad is trapped if the player is within 15 feet.</li>
            <li><b>2) Fey Fountain: </b> If players walk into the fountain at the top of the map they can roll a knowledge nature dc 30 or heal check 35 they can learn that this fountain has the ability to heal ailments. While standing inside the water once per turn a player may spend a movement action which provokes attacks of opportunity to heal 8d8 health, and cure a single status effect on them. This can even cure permanent negative levels, but only one per round, and restore ability damage, but only from a single ability score at a time. The first time a player drinks from it they gain a +4 resistance bonus to their will saving throws permanently (even after leaving the map), and can move over difficult terrain as if it were normal terrain for 10 rounds.
            <ul>
                <li><b>Permanent Negative Levels:</b> One per round</li>
                <li><b>Temporary Negative Levels:</b> 1d4 at a time</li>
                <li><b>Ability Score Damage:</b> One Ability Score at a time</li>
                <li><b>Ability Score Drain:</b> 1d6 at a time</li>
                <li><b>All Other Negative Statuses:</b> Instantly removed</li>
            </ul>   
            </li>
            
        </ul>
        <br/><br/>        
        </v-col>
    </v-row>
    <h4>Terrain of Note: </h4>
        <ul>
            <li><b>1) Flower Platform: </b> This large platform raises 20 feet into the air. there is no room underneath to move.</li>
            <li><b>1) Thigh High Water: </b> The water on each side of the center pathway counts as difficult terrain if the player is medium or smaller. Players can walk over lily pads even when its over water without it counting as difficult terrain.</li>
        </ul>
        <br/><br/>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>